import { RedWarningIcon, BigXCloseBtn} from '../components/Icons';
import { useTranslation } from 'react-i18next';
import React, { useState } from "react";



 const SubscriptionErrorPopup = () =>{
    const [showPopup, setShowPopup] = useState(true);
    const onClick = () => setShowPopup(false);
    const { t, i18n } = useTranslation();
    return(
<div>
{showPopup?
  <div onClick={onClick} id="popup-min-4-nis"className ={`popap-background`}>
  <div className="price-popup-container " >
      <RedWarningIcon className={"red-icon-warning"} />
      <p>{t(`Subscription price must be minimum ₪4 NIS`)}</p>
      <BigXCloseBtn className= "x-icon "></BigXCloseBtn>
  </div>
</div> :null}
</div>
 );

};

export default SubscriptionErrorPopup;